import PropTypes from 'prop-types';
import React from 'react';
import Icon from '@loggi/ui/components/icon';
import ViewContainer from '@loggi/ui/components/view-container';
import Col from '@loggi/ui/components/col';
import Input from 'react-input-autosize';

class SearchInput extends React.Component {
  static displayName = 'SearchInput';
  static propTypes = {
    placeholder: PropTypes.string,
    editable: PropTypes.bool
  };

  focus() {
    this.refs.input.focus();
  }

  blur() {
    this.refs.input.blur();
  }

  getInput() {
    return this.refs.input.getInput();
  }

  render() {
    const { editable, placeholder, ...inputProps } = this.props;
    return (
      <ViewContainer fluid>
        <Col size={12} gutter={{ left: 'normal', right: 'half' }}>
          {editable && (
            <Icon
              type="search"
              color="dark"
              style={{ marginRight: '0.5rem' }}
            />
          )}
          <Input
            ref="input"
            placeholder={editable ? placeholder : null}
            minWidth="5px"
            {...inputProps}
          />
        </Col>
      </ViewContainer>
    );
  }
}

export default SearchInput;
